import { cloudConfigured } from '../../lib/supabase.js';
import { useSettings } from '../../app/settingsStore.js';
import { useAuth } from './authStore.js';
import Button from '../../components/Button.jsx';
import styles from './Auth.module.scss';

/** Optional account prompt. Hidden once someone is signed in, dismisses it, or when cloud sync is not configured. */
export default function AccountPitch({ variant = 'card' }) {
  const user = useAuth((s) => s.user);
  const dismissed = useSettings((s) => s.accountPromptDismissed);
  const dismiss = useSettings((s) => s.set);
  if (!cloudConfigured || user || dismissed) return null;

  const hide = () => dismiss({ accountPromptDismissed: true });

  if (variant === 'banner') {
    return (
      <aside className={styles.banner}>
        <div>
          <p className={styles.kicker}>Recommended</p>
          <strong>Sync this device with your others</strong>
          <span>An account is optional. Your cards stay on this device either way.</span>
        </div>
        <div className={styles.bannerActions}>
          <Button variant="primary" to="/auth?mode=signup">
            Create account
          </Button>
          <Button to="/auth">Sign in</Button>
          <Button onClick={hide}>Not now</Button>
        </div>
      </aside>
    );
  }

  return (
    <aside className={styles.pitch}>
      <p className={styles.kicker}>Recommended · optional</p>
      <h2>Keep a copy in your account</h2>
      <p>
        Sign up to sync your phone, tablet, and computer, and to keep a private backup. You can skip
        this and study here first.
      </p>
      <div className={styles.pitchActions}>
        <Button variant="primary" size="lg" block to="/auth?mode=signup">
          Create a free account
        </Button>
        <Button size="lg" block to="/auth">
          I already have an account
        </Button>
        <Button size="lg" block onClick={hide}>
          Not now
        </Button>
      </div>
    </aside>
  );
}
